import { useEffect, useLayoutEffect, useState } from 'react';
import { shouldSkipPersonalSign } from 'api';
export function useHidePersonalSignEntry(senderEmail, mailConfApi, systemApi, mailId) {
    const [hideEntry, setHideEntry] = useState(false);
    useLayoutEffect(() => {
        setHideEntry(false);
    }, [senderEmail, mailId]);
    useEffect(() => {
        let canceled = false;
        if (systemApi.getIsCorpMailMode()) {
            setHideEntry(false);
            return;
        }
        (async () => {
            try {
                const entSig = await mailConfApi.getEntSignature(false, senderEmail);
                if (!canceled)
                    setHideEntry(shouldSkipPersonalSign(entSig));
            }
            catch (_e) {
                if (!canceled)
                    setHideEntry(false);
            }
        })();
        return () => {
            canceled = true;
        };
    }, [senderEmail, mailId]);
    return hideEntry;
}
